<template>
  <div class="invoice-success-container">
    <!-- 成功图标 -->
    <div class="success-icon-wrapper">
      <van-icon name="checked" class="success-icon" />
    </div>

    <!-- 成功文字 -->
    <div class="success-title">提交成功</div>
    <div class="success-desc">您的开票申请已提交，请等待审核</div>

    <!-- 提示信息 -->
    <div class="tip-card">
      <div class="tip-item">
        <van-icon name="clock-o" class="tip-icon" />
        <span class="tip-text">预计1-3个工作日内完成审核</span>
      </div>
      <div class="tip-item">
        <van-icon name="envelop-o" class="tip-icon" />
        <span class="tip-text">审核通过后发票将发送至您的邮箱</span>
      </div>
    </div>

    <!-- 关闭按钮 -->
    <div class="button-group">
      <van-button
        round
        block
        type="primary"
        @click="closePage"
        class="action-button"
      >
        关闭
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvoiceSuccess',
  methods: {
    // 关闭页面
    closePage() {
      // 尝试关闭微信浏览器窗口
      if (typeof WeixinJSBridge !== 'undefined') {
        // eslint-disable-next-line no-undef
        WeixinJSBridge.call('closeWindow')
      } else if (typeof AlipayJSBridge !== 'undefined') {
        // eslint-disable-next-line no-undef
        AlipayJSBridge.call('closeWebview')
      } else {
        // 其他情况尝试关闭窗口
        window.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-success-container {
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 32px 40px;
}

.success-icon-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #07c160 0%, #06ae56 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 8px 24px rgba(7, 193, 96, 0.3);

  .success-icon {
    font-size: 48px;
    color: #fff;
  }
}

.success-title {
  font-size: 24px;
  font-weight: bold;
  color: #323233;
  margin-bottom: 12px;
}

.success-desc {
  font-size: 14px;
  color: #969799;
  margin-bottom: 40px;
}

.tip-card {
  width: 100%;
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  margin-bottom: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

  .tip-item {
    display: flex;
    align-items: center;
    padding: 8px 0;

    &:not(:last-child) {
      margin-bottom: 4px;
    }

    .tip-icon {
      font-size: 18px;
      color: #1989fa;
      margin-right: 12px;
      flex-shrink: 0;
    }

    .tip-text {
      font-size: 14px;
      color: #646566;
      line-height: 1.5;
    }
  }
}

.button-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.action-button {
  height: 48px;
  font-size: 16px;
  font-weight: 500;
}

:deep(.van-button--primary) {
  background-color: #1989fa;
  border-color: #1989fa;
}
</style>
